<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col mx-auto text-center">
      <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse font-30">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // クエリパラメータのキーに渡す値が「true」であれば、そのキーに該当する文言を表示
    // それ以外なら、defaultで定義した値で表示する
    errorMessage() {
      const query = this.$route.query
      const keyPaired = Object.keys(this.errors).find((key) => query[key] === 'true')
      return keyPaired ? this.errors[keyPaired] : this.errors.default
    }
  },
  data() {
    return {
      errors: {
        default: '有効なメニュー・プランがございませんでした。',
        plan: '有効なプランがございませんでした。',
        publicStay: '公共の宿のサービスはご入会頂いているコースに対応しておりません。',
        stock: '指定された日付のプランがございませんでした。',
        appliy: '申込できるメニュープランがありません。'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.link-back {
  color: #333;
  font-weight: 700;
  font-size: 18px;
}
.font-30 {
  font-size: 30px;
}
</style>
